import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* Company */}
        <div className="footer-box">
          <h2 className="footer-logo">
            <span>⚡</span> Savariya Cable
          </h2>

          <p>
            Savariya Cable is a trusted manufacturer of premium electrical wires and
            cables for residential, commercial and industrial applications.
          </p>

         
        </div>

        {/* Quick Links */}
        <div className="footer-box">
          <h3>Quick Links</h3>

          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/blogs">Blogs</Link>
          <Link to="/contact">Contact</Link>
        </div>

        {/* Products */}
        <div className="footer-box">
          <h3>Categories</h3>

          <Link to="/categories/agriculture"> Agriculture</Link>
          <Link to="/categories/solar-industries"> Solar Industries</Link>
          <Link to="/categories/realestate"> Real Estate</Link>
          
        </div>

        {/* Contact */}
        <div className="footer-box">
          <h3>Contact</h3>

          <p>
            <FaMapMarkerAlt />
            Surat, Gujarat, India
          </p>

          <p>
            <FaPhoneAlt />
            +91 81416 61900
          </p>

          <p>
            <FaEnvelope />
            info@savariyacable.com
          </p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Savariya Cable. All Rights Reserved.
        </p>
      </div>

    </footer>
  );
};

export default Footer;